import React, { useCallback, useRef } from 'react';
import * as PropTypes from 'prop-types';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';

import S from './modal-business-group-clubs.module.scss';
import { CloseButton } from '../../common/buttons/close-button';
import { useOverlayClick } from '../../../helpers/hooks/use-overlay-click';
import { BUSINESS_GROUP_BY_ID_GQL } from '../../../graphql/queries/business-group-by-id-query';
import { useHistory } from 'react-router';
import { RouteConstants } from '../../routes/route-constants';
import ColorButton from '../../common/buttons/color-button';

const ModalBusinessGroupClubs = ({ onClose, id, showSelectClub = true }) => {
  const { t } = useTranslation();
  const MODAL_REF = useRef();

  useOverlayClick(MODAL_REF, onClose);

  const { data, loading, error } = useQuery(BUSINESS_GROUP_BY_ID_GQL, {
    variables: { id },
    skip: !id
  });

  const businessGroup = data?.business_group;
  const businesses = businessGroup?.businesses || [];

  const CLIENT = useApolloClient();
  const HISTORY = useHistory();
  const handleClick = useCallback((id) => {
    CLIENT.writeData({ data: { userClubId: id } });
    onClose();
    HISTORY.push({
      pathname: RouteConstants['clubSettings']
    });
  }, [CLIENT]);

  return (
    <div ref={MODAL_REF} className={S.businessGroupClubsModal}>
      <CloseButton onClick={onClose} />
      <h2 className={S.modalTitle}>
        {businessGroup
          ? t('businessGroupsPage.businesses_in_group', { groupName: businessGroup.name })
          : t('businessGroupsPage.businesses_in_group_loading')}
      </h2>

      {loading ? (
        <div className={S.loadingContainer}>
          {t('common.loading')}
        </div>
      ) : error ? (
        <div className={S.loadingContainer}>
          {t('errors.generic')}
        </div>
      ) : (
        <div className={S.clubsList}>
          {businesses.length > 0 ? (
            businesses.map(business => (
              <div
                key={business.id}
                className={S.clubItem}
              >
                <div className={S.clubInfo}>
                  <div className={S.clubName}>{business.name}</div>
                  {showSelectClub && (
                    <ColorButton color={'blue'} type={'inverted'} className='w-24' onClick={handleClick.bind(this, business.id)}>
                      {t('common.view')}
                    </ColorButton>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className={S.noClubs}>
              {t('businessGroupsPage.no_businesses_in_group')}
            </div>
          )}
        </div>
      )}
      <button
        type="button"
        className={S.closeButton}
        onClick={onClose}
      >
        {t('common.close')}
      </button>
    </div>
  );
};

ModalBusinessGroupClubs.displayName = 'ModalBusinessGroupClubs';

ModalBusinessGroupClubs.propTypes = {
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

export { ModalBusinessGroupClubs };
